export default "__VITE_ASSET__DkxZjBUt__"